import { FloatElement } from './float-element'
import { BaseComponent } from '../base-component'
import { $el } from 'src/scripts/utils/utils'

export class TooltipTrigger extends BaseComponent {
  mountComponent(): void {
    this.addListener(this, 'mouseenter', this.handleMouseEnter)
    this.addListener(this, 'mouseleave', this.handleMouseLeave)
  }

  handleMouseEnter = (): void => {
    const floatElement: FloatElement = $el(`#${this.dataset.floatElementId}`)
    floatElement?.show()
  }

  handleMouseLeave = (): void => {
    const floatElement: FloatElement = $el(`#${this.dataset.floatElementId}`)
    floatElement?.hide()
  }

  setExpand(isExpanded: boolean): void {
    this.setAttribute('data-aria-expanded', isExpanded ? 'true' : 'false')
  }
}
